<template>
	<span v-if="showBadge" class="badge">
		<span>{{ unreadNotifications }}</span>
	</span>
</template>

<script>
export default {
	name: 'NotificationBadge',
	computed: {
		unreadNotifications() {
			return this.$store.getters.unreadNotifications.length
		},
		showBadge() {
			return this.unreadNotifications > 0
		},
	},
	created() {
		// Load unread notifications
		this.loadUnreadNotifications()
	},
	methods: {
		loadUnreadNotifications() {
			// Get unread notifications (without trigger toast)
			this.$store.dispatch('retrieveUnreadNotifications', { toast: false })
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/notifications/NotificationBadge.vue